import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { StoreType } from '../../types';
import EventService from '../../services/eventService';
import { generateSearchParam } from '../utils';
import { RootState } from '../';
import eventSlice from './eventSlice';

export const eventActions = eventSlice.actions;

export const fetchAllEvents = (param: StoreType): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    const searchParam = generateSearchParam(param.searchParam);
    let response: any = await EventService.getEvent(param, searchParam);

    dispatch(
      eventActions.setEvents({ searchInput: param.searchParam, data: response.data, countToGet: param.countToGet }),
    );

    /*while (response && response.data?.nextIndex && response.data?.events.length < param.limit) {
      param.lastIndex = response.data.nextIndex;
      const response2 = await EventService.getEvent(param, searchParam);
      if (response2.data.events.length > 0) {
        response.data.events.push(response2.data.events);
      }
      response.data.nextIndex = response2.data.nextIndex;
      console.log('Continue Looking for more data...');
      console.log(response);
      dispatch(eventActions.setEvents({ searchInput: param.searchParam, data: response2.data }));
    }*/
  };
};

export const clearEvents = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(eventActions.clearEvents());
  };
};
